import TableCustomViewOptionsStore from "csi/middleware/customView/options/TableCustomViewOptionsStore";
import { ComponentItem } from "designSystem/types/component-item-types";
import { action, computed, makeObservable } from "mobx";
import { ChangeEvent, FunctionComponent } from "react";
import CustomViewDialogStore from "csi/middleware/customView/CustomViewDialogStore";
import { ICustomViewTimelineDropDownOptions, ICustomViewTimelineOptions, TimelineRangeType } from "./CustomViewTimelineOptions";

/**
 * This store contains information about Timeline options
 */
class TimelineCustomViewOptionsStore extends TableCustomViewOptionsStore<ICustomViewTimelineOptions> {
	/** all the dropdown boxes selection options for the custom view */
	readonly timelineDropDownOptions: ICustomViewTimelineDropDownOptions;

	constructor(
		timelineDropDownOptions: ICustomViewTimelineDropDownOptions,
		component: FunctionComponent,
		customViewDialogStore: CustomViewDialogStore,
		options?: ICustomViewTimelineOptions,
	) {
		super(timelineDropDownOptions, component, customViewDialogStore, options);
		makeObservable(this);
		this.timelineDropDownOptions = timelineDropDownOptions;
	}

	@action onChangeSelectedTimelineRange = (event: ChangeEvent<{}>, value: ComponentItem): void => {
		this.options.timelineRange = value.id as TimelineRangeType;
	};

	@action onChangeSelectedTimelineWeeks = (event: ChangeEvent<{}>, item: ComponentItem): void => {
		this.options.timelineWeeks = item.value;
	};
	
	@computed get selectedTimelineWeeks(): ComponentItem {
		const { timelineWeeks } = this.options;
		return this.timelineDropDownOptions.timelineWeeksOptions.find((item) => item.value === timelineWeeks);
	};

	@computed get selectedTimelineRange(): ComponentItem {
		const { timelineRange } = this.options;
		return this.timelineDropDownOptions.timelineRangeOptions.find((item) => item.id === timelineRange);
	};
}

export = TimelineCustomViewOptionsStore;